<mat-card>
  <mat-card-title>Error</mat-card-title>
  <mat-card-content fxLayout="row" fxLayout.xs="column">
    <p>errortext</p>
  </mat-card-content>
  <mat-card-actions fxLayout="row">
    <div fxFlex fxFlexFill></div>
    <button mat-raised-button type="submit" color="accent">Dismiss</button>
  </mat-card-actions>
</mat-card>
